// @ts-nocheck
import { YStack } from 'tamagui';
import { PageFrame } from '../components/PageFrame';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { PortfolioFrieze } from '../components/PortfolioFrieze';
import { Platform } from '../components/Platform';
import { ProductRoster } from '../components/ProductRoster';
import { ShippedRecently } from '../components/ShippedRecently';
import { Founder } from '../components/Founder';
import { FAQ } from '../components/FAQ';
import { ConnectorCTA } from '../components/ConnectorCTA';
import { WaitlistCTA } from '../components/WaitlistCTA';
import { Footer } from '../components/Footer';

/**
 * Section order follows the pattern that works for this category: state the
 * thesis, prove the company is real, show the work, then answer who is behind it
 * before asking for anything.
 *
 * Founder sits directly before the CTA on purpose. It occupies the slot a funded
 * competitor fills with customer logos and named endorsements — the record is
 * what makes "one person, eight products" read as credible rather than absurd,
 * and it is the last thing a visitor should read before deciding.
 */
export default function LandingPage({ theme, toggleTheme }) {
  return (
    <PageFrame>
      <Header theme={theme} toggleTheme={toggleTheme} />
      <Hero />
      <PortfolioFrieze />
      <Platform />
      <ProductRoster />
      <ShippedRecently />
      <Founder theme={theme} />
      <FAQ />
      <ConnectorCTA />
      <Footer />
    </PageFrame>
  );
}
